import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTopBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowTopBottom"><Path fillRule="evenodd" clipRule="evenodd" d="M7.00015 2.58594L12.4144 8.00015L11.0002 9.41436L8.00015 6.41436V21.0002H6.00015V6.41436L3.00015 9.41436L1.58594 8.00015L7.00015 2.58594ZM18.0002 3.00015V17.5859L21.0002 14.5859L22.4144 16.0002L17.0002 21.4144L11.5859 16.0002L13.0002 14.5859L16.0002 17.5859V3.00015H18.0002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTopBottom;
